import { styled } from '@mui/system';
import { ButtonGroup } from '@mui/material';

export const StyledButtonGroup = styled(ButtonGroup)(({ theme }) => ({
  '& button': {
    [theme.breakpoints.down('sm')]: {
      padding: '3px'
    }
  },
  '& a': {
    [theme.breakpoints.down('sm')]: {
      padding: '3px'
    }
  }
}));

export const GroupButtonLabel = styled('span')(({ theme }) => ({
  margin: '0 16px',
  [theme.breakpoints.down('sm')]: {
    margin: '0 12px'
  }
}));
